import * as React from 'react';
import { Link, RouteComponentProps } from 'react-router-dom';
import { fetchApi } from '../../services/api';
import { debounce } from 'ts-debounce';
import * as moment from 'moment';
import { Grid, GridColumn as Column, GridCell, GridToolbar } from '@progress/kendo-react-grid';
import { SortDescriptor, orderBy } from '@progress/kendo-data-query';
import LoadingPanel from '../LoadingPanel';
const DocumentTitle = require('react-document-title');

type Props = RouteComponentProps<{}>;

var InsertItem: any = null;

type State = {
    sort: SortDescriptor[];
    origAttendances: GlobalSearchResult[];
    attendances: GlobalSearchResult[];
    ChildIds: number[];
    noResults: boolean;
    Facilities: Array<{ FacilityId: number, Name: string }>;
    isLoading: boolean;
}

export interface GlobalSearchResult {
    ScheduleId: number;
    ChildId: number;
    Name: string;
    AccountId: number;
    AccountName: string;
    Link: string;
    CheckInTime: DateTimeValue | null;
    CheckOutTime: DateTimeValue | null;
    CheckInTimeInEdit: Boolean;
    CheckOutTimeInEdit: Boolean;
    InEdit: Boolean | undefined;
    FacilityIANA: string;
    RowId: number; //Used for zero/empty records
    [key: string]: any;
}

export type DateTimeValue = {
    DateTime: Date;
    IANA: string;
    DateTimeString: string;
    LocalMinDateTime: Date;
    LocalMaxDateTime: Date;
}

class ChildNameCell extends GridCell {
    render() {
        return (
            <td>
                <span className="k-icon k-i-insert-down" title="Insert new attendance row for this child" style={{ color: "#007bff", fontSize: "16px", cursor: "pointer" }} onClick={() => InsertItem(this.props.dataItem)}></span>
                &nbsp;
                <Link style={{ color: '#007bff' }} to={`/child/${this.props.dataItem.ChildId}`}>
                    {this.props.dataItem.Name}
                </Link>
            </td>
        );
    }
}

class AccountNameCell extends GridCell {
    render() {
        return (
            <td>
                <Link style={{ color: '#007bff' }} to={`/accounts/${this.props.dataItem.AccountId}`}>
                    {this.props.dataItem.AccountName}
                </Link>
            </td>
        );
    }
}

class Attendance extends React.Component<Props, State> {

    CheckInCell: typeof GridCell
    CheckOutCell: typeof GridCell
    EditCell: typeof GridCell

    private _RowId: number = 0;
    private SearchValue: React.RefObject<HTMLInputElement>;

    constructor(props: Props) {
        super(props);

        this.state = {
            attendances: [],
            origAttendances: [],
            noResults: false,
            sort: [],
            ChildIds: [],
            Facilities: [],
            isLoading: false
        }

        InsertItem = this.insertItem.bind(this);

        this.isNV = this.isNV.bind(this);
        this.enterInsert = this.enterInsert.bind(this);
        this.itemChange = this.itemChange.bind(this);
        this.sortChange = this.sortChange.bind(this);
        this.SearchValue = React.createRef();

        const enterEdit = this.enterEdit.bind(this);
        const remove = this.remove.bind(this);
        const save = this.save.bind(this);
        const cancel = this.cancel.bind(this);
        const CheckInFunc = this.CheckInFunc.bind(this);
        const CheckOutFunc = this.CheckOutFunc.bind(this);

        class CheckIn extends GridCell {
            render() {
                if (!this.props.dataItem.InEdit && this.props.dataItem.CheckInTime) {
                    return (
                        <td>{moment.utc(this.props.dataItem.CheckInTime.DateTime).tz(this.props.dataItem.CheckInTime.IANA).format("MM/DD/YYYY hh:mm A z")}</td>
                    );
                } else if (this.props.dataItem.CheckInTimeInEdit || this.props.dataItem.CheckInTime) {
                    if (!this.props.dataItem.CheckInTime) {
                        this.props.dataItem.CheckInTime = {
                            DateTime: moment().toDate(),
                            IANA: this.props.dataItem.FacilityIANA,
                            DateTimeString: moment.utc(moment().toDate()).tz(this.props.dataItem.FacilityIANA).format("YYYY-MM-DDTHH:mm").toString()
                        } as DateTimeValue;
                    } else if (!this.props.dataItem.CheckInTime.DateTimeString) {
                        this.props.dataItem.CheckInTime.DateTimeString = moment.utc(this.props.dataItem.CheckInTime.DateTime).tz(this.props.dataItem.CheckInTime.IANA).format("YYYY-MM-DDTHH:mm").toString();
                    }
                    //if (!this.props.dataItem.CheckInTime.LocalMinDateTime)
                    //    this.props.dataItem.CheckInTime.LocalMinDateTime = moment.utc().subtract(2, "days").tz(this.props.dataItem.CheckInTime.IANA).format("YYYY-MM-DDTHH:mm").toString();
                    //if (!this.props.dataItem.CheckInTime.LocalMaxDateTime)
                    //    this.props.dataItem.CheckInTime.LocalMaxDateTime = moment.utc().add(2, "days").tz(this.props.dataItem.CheckInTime.IANA).format("YYYY-MM-DDTHH:mm").toString();
                    return (
                        <td>
                            <div>
                                <input className="form-control" type="datetime-local"
                                    // min="2017-06-07T00:00" max="2019-06-14T00:00"
                                    defaultValue={this.props.dataItem.CheckInTime.DateTimeString}
                                    onChange={this.handleChange.bind(this)} />
                            </div>
                        </td>
                    )
                } else
                    return (<td><button role="button" className="btn btn-primary" disabled={!this.props.dataItem.ChildId} onClick={() => CheckInFunc(this.props.dataItem)}>Check-In</button></td>);
            }

            private handleChange(e: any) {
                if (this.props.onChange) {
                    this.props.dataItem.CheckInTime.DateTimeString = e.target.value;
                    this.props.onChange({
                        dataItem: this.props.dataItem,
                        field: this.props.field,
                        syntheticEvent: e.syntheticEvent,
                        value: e.target.value
                    });
                }
            }
        }

        class CheckOut extends GridCell {
            render() {
                if (!this.props.dataItem.InEdit && this.props.dataItem.CheckOutTime) {
                    return (
                        <td>{moment.utc(this.props.dataItem.CheckOutTime.DateTime).tz(this.props.dataItem.CheckOutTime.IANA).format("MM/DD/YYYY hh:mm A z")}</td>
                    );
                } else if (this.props.dataItem.CheckOutTimeInEdit || this.props.dataItem.CheckOutTime) {
                    if (!this.props.dataItem.CheckOutTime) {
                        this.props.dataItem.CheckOutTime = {
                            DateTime: moment().toDate(),
                            IANA: this.props.dataItem.FacilityIANA,
                            DateTimeString: moment.utc(moment().toDate()).tz(this.props.dataItem.FacilityIANA).format("YYYY-MM-DDTHH:mm").toString()
                        } as DateTimeValue;
                    } else if (!this.props.dataItem.CheckOutTime.DateTimeString) {
                        this.props.dataItem.CheckOutTime.DateTimeString = moment.utc(this.props.dataItem.CheckOutTime.DateTime).tz(this.props.dataItem.CheckOutTime.IANA).format("YYYY-MM-DDTHH:mm").toString();
                    }
                    //if (!this.props.dataItem.CheckOutTime.LocalMinDateTime)
                    //    this.props.dataItem.CheckOutTime.LocalMinDateTime = moment.utc().subtract(2, "days").tz(this.props.dataItem.CheckOutTime.IANA).format("YYYY-MM-DDTHH:mm").toString();
                    //if (!this.props.dataItem.CheckOutTime.LocalMaxDateTime)
                    //    this.props.dataItem.CheckOutTime.LocalMaxDateTime = moment.utc().add(2, "days").tz(this.props.dataItem.CheckOutTime.IANA).format("YYYY-MM-DDTHH:mm").toString();
                    return (
                        <td>
                            <div>
                                <input className="form-control" type="datetime-local"
                                    // min="2017-06-07T00:00" max="2019-06-14T00:00"
                                    defaultValue={this.props.dataItem.CheckOutTime.DateTimeString}
                                    onChange={this.handleChange.bind(this)} />
                            </div>
                        </td>
                    )
                } else
                    return (<td><button role="button" className="btn btn-primary" disabled={!this.props.dataItem.CheckInTime} onClick={() => CheckOutFunc(this.props.dataItem)}>Check-Out</button></td>);
            }

            private handleChange(e: any) {
                if (this.props.onChange) {
                    this.props.dataItem.CheckOutTime.DateTimeString = e.target.value;
                    this.props.onChange({
                        dataItem: this.props.dataItem,
                        field: this.props.field,
                        syntheticEvent: e.syntheticEvent,
                        value: e.target.value
                    });
                }
            }
        }

        class Edit extends GridCell {
            public render() {
                return !this.props.dataItem.InEdit ?
                    (<td>
                        <button
                            disabled={(this.props.dataItem.ScheduleId == 0)}
                            className="k-primary k-button k-grid-edit-command"
                            onClick={() => enterEdit(this.props.dataItem)}
                        >Edit</button>

                        {(this.props.dataItem.ScheduleId > 0) &&
                            <button
                                className="k-button k-grid-remove-command"
                                onClick={() => confirm('Delete?') &&
                                    remove(this.props.dataItem)}
                            >Delete</button>}
                    </td>
                    ) : (
                        <td>
                            <button
                                className="k-button k-grid-save-command"
                                onClick={() => save(this.props.dataItem)}
                                disabled={!this.props.dataItem.Name}
                            >Save</button>
                            <button
                                className="k-button k-grid-cancel-command"
                                onClick={() => cancel(this.props.dataItem)}
                            >Cancel</button>
                        </td>
                    );
            }
        }



        //class CommandCell extends GridCell {
        //    render() {
        //        return (
        //            <td>
        //                {(this.props.dataItem.CheckInTime && !this.props.dataItem.CheckOutTime) &&
        //                    <button role="button" className="btn btn-primary" onClick={() => checkOut(this.props.dataItem)}>Check-Out</button>}
        //                {(!this.props.dataItem.CheckInTime || this.props.dataItem.CheckOutTime) &&
        //                    <button role="button" className="btn btn-primary" onClick={() => checkIn(this.props.dataItem)}>Check-In</button>}
        //            </td>
        //        );
        //    }
        //}

        //this.DateTimeCell = DateTimeCell;
        //this.CheckInCell = CheckInCell;
        //this.CommandCell = CommandCell;
        this.CheckInCell = CheckIn;
        this.CheckOutCell = CheckOut;
        this.EditCell = Edit;
    }

    public componentWillMount() {
        this.search("");
    }

    public render() {
        return <div>
            <DocumentTitle title="Attendance" />
            <div className="row">
                <div className="col">
                    <h1>Attendance</h1>
                </div>
                <div className="col">
                    <Link
                        role="button"
                        className="btn btn-primary float-right"
                        to={'/attendance/print'}
                    >
                        Print
                    </Link>
                </div>
            </div>
            <input
                ref={this.SearchValue}
                autoFocus
                type="text"
                className="form-control"
                onChange={(e) => this.searchDebounced(e.target.value)}
                autoComplete="off"
                placeholder="Search for Children"
                aria-label="Search for Children"
            />
            <br />
            {this.state.isLoading && <LoadingPanel />}
            <Grid data={this.state.attendances}
                sortable={{
                    allowUnsort: true
                }}
                sort={this.state.sort}
                onItemChange={this.itemChange}
                onSortChange={this.sortChange}
                editField="InEdit">
                <GridToolbar>
                    {
                        this.state.attendances.filter(p => p.InEdit).length > 0 && (
                            <button
                                title="Cancel current changes"
                                className="k-button"
                                onClick={(e) => this.setState({ attendances: this.state.origAttendances.slice() })
                                }
                            > Cancel current changes
                        </button>)
                    }
                </GridToolbar >
                <Column field="Name" title="Name" cell={ChildNameCell} />
                <Column field="AccountName" title="Account Name" cell={AccountNameCell} />
                <Column field="CheckInTime" title="Check-in time" cell={this.CheckInCell} filter="date" />
                <Column field="CheckOutTime" title="Check-out time" cell={this.CheckOutCell} filter="date" />
                <Column cell={this.EditCell} sortable={false} />
            </Grid>
        </div>
    }

    private enterInsert(event: any) {
        const dataItem = {} as GlobalSearchResult;
        dataItem.InEdit = true;
        dataItem.RowId = this._RowId += 1;
        const newAttendee = this.state.attendances.slice();
        newAttendee.unshift(dataItem as GlobalSearchResult);
        this.update(newAttendee, dataItem as GlobalSearchResult);
        this.setState({
            attendances: newAttendee
        });
    }

    private copyItem(dataItem: GlobalSearchResult) {
        return JSON.parse(JSON.stringify(dataItem));
    }

    private insertItem(dataItem: GlobalSearchResult) {

        let idx: number = this.find(this.state.attendances, dataItem) as number;
        var newDataItem = this.copyItem(dataItem);
        //const dataItem = {} as GlobalSearchResult;

        newDataItem.RowId = this._RowId += 1;
        newDataItem.ScheduleId = 0;
        newDataItem.InEdit = false;
        newDataItem.CheckInTimeInEdit = false;
        newDataItem.CheckOutTimeInEdit = false;
        newDataItem.CheckOutTime = null;
        newDataItem.CheckInTime = null;

        const newAttendee = this.state.attendances.slice();

        newAttendee.splice(idx + 1, 0, newDataItem);

        //newAttendee.unshift(newDataItem as GlobalSearchResult);
        // this.update(newAttendee, newDataItem as GlobalSearchResult);
        this.setState({
            attendances: newAttendee
        });
    }

    private itemChange(event: any) {
        const value = event.value;
        const name = event.field;
        if (!name) {
            return;
        }
        const updatedData = this.state.attendances.slice();
        this.update(updatedData, event.dataItem).then((item) => {
            switch (name) {
                case "CheckInTime":
                case "CheckOutTime":
                    ((item as any)[name] as DateTimeValue).DateTime = value;
                    break;
                default:
                    (item as any)[name] = value;
                    break;
            }
            this.setState({ attendances: updatedData });
        });
    }

    private isNV(value: number) {
        if (isNaN(value) || value === 0)
            return false;
        return true;
    }

    private find(data: GlobalSearchResult[], item: GlobalSearchResult) {
        return data.findIndex(p => p === item
            || (this.isNV(item.ScheduleId) && p.ScheduleId === item.ScheduleId)
            || (this.isNV(item.RowId) && item.RowId == p.RowId))
    }

    private async update(data: GlobalSearchResult[], item: GlobalSearchResult, remove: boolean = false): Promise<GlobalSearchResult> {
        let updated;
        let index = this.find(data, item);
        if (index >= 0) {
            updated = Object.assign({}, item);
            data[index] = updated;
        } else {
            updated = Object.assign({}, item);
            data.unshift(updated);
            index = 0;
        }

        if (remove)
            data = data.splice(index, 1);

        return data[index];
    }

    private searchDebounced = debounce(this.search, 250);

    private search(searchTerm: string) {

        if (searchTerm.length > 0 && searchTerm.length < 3) { //empty searches all
            this.setState({ attendances: [], noResults: false });
            return;
        }

        const postData = {
            SearchTerm: searchTerm,
            FacilityID: localStorage.getItem("FACILITY_ID")
        }
        //moment.utc(value.DateTime).tz(value.IANA).format("MM/DD/YYYY hh:mm A")
        //_data[index

        this.setState({ isLoading: true });
        fetchApi('/api/Attendance/AttendanceSearch', postData, 'POST').then((_data: GlobalSearchResult[]) => {
            _data.map(element => { element.RowId = ++this._RowId; });
            this.setState({ attendances: _data, origAttendances: JSON.parse(JSON.stringify(_data)), noResults: _data.length === 0, isLoading: false });
            // _data.forEach(element => { console.log("A: " + element.RowId); });
        });
    }

    private enterEdit(dataItem: GlobalSearchResult) {
        this.update(this.state.attendances, dataItem).then((data) => {
            data.InEdit = true;
            this.setState({ attendances: this.state.attendances.slice() });
        });
    }

    //private remove(dataItem: GlobalSearchResult) {
    //    dataItem.InEdit = undefined;
    //    this.update(this.state.attendances, dataItem, true);
    //    this.update(this.state.origAttendances, dataItem, true);
    //    this.setState({ attendances: this.state.attendances.slice() });
    //    if (dataItem.ScheduleId) {
    //        fetchApi(`api/Attendance/Delete/${dataItem.ScheduleId}`, {}, 'DELETE');
    //    }
    //}

    private remove(dataItem: GlobalSearchResult) { //remove has been converted to behave as a reset
        dataItem.InEdit = false;
        dataItem.CheckInTimeInEdit = false;
        dataItem.CheckOutTimeInEdit = false;
        dataItem.CheckInTime = null;
        dataItem.CheckOutTime = null;
        fetchApi(`api/Attendance/Delete/${dataItem.ScheduleId}`, {}, 'DELETE');
        dataItem.ScheduleId = 0;
        this.update(this.state.attendances, dataItem, false);
        this.update(this.state.origAttendances, dataItem, false);
        this.setState({ attendances: this.state.attendances.slice() });
    }

    private isInAndOutDateOutOfRange(dataItem: GlobalSearchResult) {
        if (dataItem.CheckInTime != null && dataItem.CheckOutTime != null)
            return (moment(dataItem.CheckOutTime.DateTime).diff(dataItem.CheckInTime.DateTime, "m") < 0);
        return false;
    }

    private save(dataItem: GlobalSearchResult) {
        if (dataItem.CheckInTime != null) {
            if (!moment(dataItem.CheckInTime.DateTimeString).isValid()) {
                alert('Check-in date/time is invalid');
                return;
            } else {
                dataItem.CheckInTime.DateTime = moment(dataItem.CheckInTime.DateTimeString).tz(dataItem.CheckInTime.IANA).utc().toDate();
            }
        }

        if (dataItem.CheckOutTime != null) {
            if (!moment(dataItem.CheckOutTime.DateTimeString).isValid()) {
                alert('Check-in date/time is invalid');
                return;
            } else {
                dataItem.CheckOutTime.DateTime = moment(dataItem.CheckOutTime.DateTimeString).tz(dataItem.CheckOutTime.IANA).utc().toDate();
            }
        }

        if (this.isInAndOutDateOutOfRange(dataItem)) {
            alert('Check-out time must be after check-in time');
            return;
        }

        this.setState({ isLoading: true });
        if (dataItem.ScheduleId > 0) {
            fetchApi(`api/Attendance/Save/${dataItem.ScheduleId}`, dataItem, 'POST').then((response: any) => {
                //dataItem.ScheduleId = response.ScheduleId as number;
                dataItem.InEdit = undefined;
                this.update(this.state.origAttendances, dataItem as GlobalSearchResult);
                this.setState({ attendances: this.state.attendances.slice() });
            }).catch(function (error) {
                alert(error.message);
            }).then(() => this.setState({ isLoading: false }));
        } else {
            fetchApi(`api/Attendance/Create`, dataItem, 'POST').then((response: any) => {
                dataItem.InEdit = undefined;
                dataItem.ScheduleId = response.ScheduleId as number;
                this.update(this.state.origAttendances, dataItem as GlobalSearchResult);
                this.setState({ attendances: this.state.attendances.slice() }, () => {
                    //this.InsertItem(dataItem);
                });
            }).catch(function (error) {
                alert(error.message);
            }).then(() => this.setState({ isLoading: false }));
        }
    }

    private CancelRequest(dataItem: GlobalSearchResult) {
        // dataItem.InEdit = true;
        this.setState({ isLoading: false });
    }

    private CheckOut(dataItem: GlobalSearchResult) {
        const data = {}
        this.setState({ isLoading: true });
        fetchApi(`/api/Attendance/CheckOut/${dataItem.ChildId}`, data, 'POST')
            .then((response) => {
                // TODO: check response
                if (this.SearchValue.current) {
                    this.search(this.SearchValue.current.value);
                }
                this.setState({ isLoading: false });
            })
            .catch(() => {
                alert(`Unable to check-out ${dataItem.Name}`);
            });
    }

    private cancel(dataItem: GlobalSearchResult) {
        dataItem.InEdit = false;
        dataItem.CheckInTimeInEdit = false;
        dataItem.CheckOutTimeInEdit = false;
        if (dataItem.ScheduleId > 0) {
            let originalItem: GlobalSearchResult = this.state.origAttendances.find(p => p.ScheduleId === dataItem.ScheduleId) as GlobalSearchResult;

            //console.log(this.state.origAttendances.find(p => p.ScheduleId === dataItem.ScheduleId));
            //console.log(this.state.attendances.find(p => p.ScheduleId === dataItem.ScheduleId));

            this.update(this.state.attendances, this.copyItem(originalItem));
            //} else if (dataItem.ChildId > 0) {
            //    let originalItem = this.state.origAttendances.find(p => p.ChildId === dataItem.ChildId); //this work as there's only child per day shown
            //    this.update(this.state.attendances, originalItem as GlobalSearchResult);
            //} else if (dataItem.RowId > 0) {
            //    let originalItem = this.state.origAttendances.find(p => p.RowId === dataItem.RowId); //this work as there's only child per day shown
            //    this.update(this.state.attendances, originalItem as GlobalSearchResult);
        } else { //empty record
            //dataItem.InEdit = true; //in case you have multiple zer0 empty records
            //console.log(dataItem.RowId);
            let originalItem: GlobalSearchResult = this.state.origAttendances.find(p => p.RowId === dataItem.RowId) as GlobalSearchResult;
            //console.log(originalItem);
            this.update(this.state.attendances, this.copyItem(originalItem)); //No child and no schedule id, meaning the add new row was never created, so remove it
            //this.update(this.state.attendances, dataItem, false); //No child and no schedule id, meaning the add new row was never created, so remove it
        }
        this.setState({ attendances: this.state.attendances.slice() });
    }

    private CheckIn(dataItem: GlobalSearchResult) {
        dataItem.InEdit = true;
        const data = {}
        this.setState({ isLoading: true });
        fetchApi(`/api/Attendance/CheckIn/${dataItem.ChildId}`, data, 'POST')
            .then((response) => {
                // TODO: check response
                if (this.SearchValue.current) {
                    this.search(this.SearchValue.current.value)
                }
                this.setState({ isLoading: false });
            })
            .catch(() => {
                alert(`Unable to check-in ${dataItem.Name}`);
            });
    }

    private sortChange(event: any) {
        this.setState({
            sort: event.sort,
            attendances: orderBy(this.state.attendances, event.sort)
        });
    }

    private CheckInFunc(dataItem: GlobalSearchResult) {
        this.update(this.state.attendances, dataItem).then((data) => {
            data.InEdit = true;
            data.CheckInTimeInEdit = true;
            this.setState({ attendances: this.state.attendances.slice() });
        });
    }

    private CheckOutFunc(dataItem: GlobalSearchResult) {
        this.update(this.state.attendances, dataItem).then((data) => {
            data.InEdit = true;
            data.CheckOutTimeInEdit = true;
            this.setState({ attendances: this.state.attendances.slice() });
        });
    }
}

export default Attendance;
